import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 0634B479-2104-4AF4-B442-2E5C407EBEE1
 * name bookmark-remove-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-remove-outline.svg
 * tags
 */
export const BookmarkRemoveOutlineIcon = createSvgIcon(<><path d="M7 3C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.89 18.1 3 17 3H7M7 5H17V18L12 15.82L7 18V5M9.88 7.47L8.47 8.88L10.59 11L8.47 13.12L9.88 14.54L12 12.42L14.12 14.53L15.54 13.12L13.42 11L15.53 8.88L14.12 7.47L12 9.59L9.88 7.47Z" /></>, 'BookmarkRemoveOutlineIcon');
export default BookmarkRemoveOutlineIcon